export class EventEmitter {
    constructor() {
        this._listeners = new Map();
    }
    on(name, listener) {
        const listeners = this._getListeners(name);
        listeners.add(listener);
        void this.emit('_listenerAdded', 
        // @ts-expect-error
        { data: { event: name, listener, newListenerCount: listeners.size } });
        return () => {
            listeners.delete(listener);
            void this.emit('_listenerRemoved', 
            // @ts-expect-error
            { data: { event: name, listener, newListenerCount: listeners.size } });
        };
    }
    async emit(name, ...options) {
        await this._emitSequential(name, options[0]);
    }
    async _emitSequential(name, options) {
        const listeners = this._getListeners(name);
        for (const listener of listeners.values()) {
            await this._runListener(listener, options);
        }
    }
    async _runListener(listener, options) {
        try {
            // @ts-expect-error
            await listener(options.data);
        }
        catch (err) {
            if (typeof options?.onListenerError === 'function') {
                options.onListenerError(err);
            }
            else {
                throw err;
            }
        }
    }
    _getListeners(name) {
        let listeners = this._listeners.get(name);
        if (listeners === undefined) {
            listeners = new Set();
            this._listeners.set(name, listeners);
        }
        return listeners;
    }
    getListenersCount(name) {
        const listeners = this._getListeners(name);
        return listeners.size;
    }
}
//# sourceMappingURL=index.js.map